import ky from 'ky';
import { z } from 'zod';
import { ENV } from 'src/utils/env';
import { getHeadersWithBearerToken } from 'src/utils/get-auth-with-bearer';

const CREATE_ORG_PARAMS_SCHEMA = z.object({
  uuid: z.string(),
  org_name: z.string(),
  org_id: z.string(),
  logo_url: z.string(),
});

const CREATE_ORG_RESPONSE_SCHEMA = z.object({
  message: z.string(),
});

export type CreateOrgParams = z.infer<typeof CREATE_ORG_PARAMS_SCHEMA>;

export const createOrgPromise = async (params: CreateOrgParams) => {
  try {
    const headers = getHeadersWithBearerToken();
    headers.append('Content-Type', 'application/json');

    const parsedParams = CREATE_ORG_PARAMS_SCHEMA.safeParse(params);

    if (!parsedParams.success) {
      console.error('Invalid params', parsedParams.error);
      return false;
    }

    const response = await ky
      .post(`${ENV.API_URL}/external-user-management/set-org/`, { body: JSON.stringify(params), headers })
      .json();

    const parsedResponse = CREATE_ORG_RESPONSE_SCHEMA.safeParse(response);

    if (!parsedResponse.success) {
      console.error('Invalid response', parsedResponse.error);
      return false;
    }

    return parsedResponse?.data?.message?.includes('created');
  } catch (error) {
    console.error('Error creating org', error);
    return false;
  }
};
